import { Model } from '@vuex-orm/core'

export default class Note extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'gdprlogs'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      type: this.attr(null),
      consent_method: this.attr(null),
      content: this.attr(null),
      candidate_id: this.attr(null),
      author_user_id: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Gdprlog.js